export default __webpack_public_path__ + "static/media/gameplay-header-new.6f152d34.png";